import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { getISODateStringIgnoringTimezone } from '@mng/mng-ts-helpers';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';

@Component({
  selector: 'mng-inputfield-date',
  imports: [
    MatFormField,
    NgStyle,
    ExtendedModule,
    MatSuffix,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatError
  ],
  templateUrl: './input-field-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldDateComponent extends InputFieldBaseComponent {
  readonly min = input<Date>();
  readonly max = input<Date>();

  setValueAsISOString(value: Date | null) {
    if (value) {
      const isoDate = getISODateStringIgnoringTimezone(value);
      this.field().control.setValue(isoDate);
    }
  }
}
